// src/components/GlassPanel.js
export function GlassPanel({
  children,
  className = "",
  rounded = "rounded-3xl",
}) {
  return (
    <div
      className={`relative ${rounded} 
                  shadow-[0_8px_32px_rgba(0,0,0,0.2)] ${className}`}
    >
      {/* Background/blur layer that IS clipped */}
      <div
        className={`absolute inset-0 ${rounded} overflow-hidden pointer-events-none`}
      >
        <div className="absolute inset-0 bg-background/10 backdrop-blur-xl backdrop-saturate-150" />
        <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent" />
      </div>

      {/* Content sits above, not clipped */}
      <div className="relative p-4 h-full">{children}</div>
    </div>
  );
}
